// rem等比适配配置文件
// 基准大小
const baseSize = 12

export const pxTorem = pxValue => {
  return pxValue / baseSize
}

export const getFontSize = () => {
  // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 1366
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  let num = baseSize * Math.min(scale, 1)
  return num.toFixed(3) + 'px'
}

// 设置 rem 函数
function setRem() {
  let fontSize = getFontSize()
  document.documentElement.style.fontSize = fontSize
}
// 初始化
setRem()

window.addEventListener('resize', () => {
  setRem()
})



// WEBPACK FOOTER //
// ./src/utils/rem.js